import GlobalFilter from "../../Utility/GlobalFilter/GlobalFilter";

export default function ClientFilter({
  listingFilter,
  handleFilterChange,
  handleFilterReset,
  applyFilters,
}) {
  const fields = [
    {
      type: "input",
      name: "clientName",
      label: "Client Name",
      placeholder: "Enter client name",
    },
    {
      type: "dropdown",
      name: "status",
      label: "Status",
      options: ["Active", "On Hold", "Inactive"],
      placeholder: "Select Status",
    },
    {
      type: "input",
      name: "contactPerson",
      label: "Contact Person",
      placeholder: "Enter contact person",
    },
  ];

  return (
    <GlobalFilter
      listingFilter={listingFilter}
      handleFilterChange={handleFilterChange}
      handleFilterReset={handleFilterReset}
      applyFilters={applyFilters}
      fields={fields}
      buttonWidth="w-full md:w-auto"
      flexClassName="flex flex-wrap md:flex-nowrap gap-2 items-end"
    />
  );
}
